import './Card.css';

function Card({ header, children }) {
    return (
        <div className='content'>
            <div className='card'>
                <h2>{header}</h2>
                {children}
            </div>
        </div>
    )
}

export default Card;